<template>
  <td :class="value.id ? 'danger' : ''">
    <v-menu offset-y v-if="!disabled">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on" block small dense>
          {{ value.comment || "–" }}
        </v-btn>
      </template>
      <v-list dense subheader>
        <v-subheader>Grund für Sperrung</v-subheader>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :disabled="item === value.comment"
          @click="update(item)"
        >
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>Mögliche Aktionen</v-subheader>
        <v-list-item :disabled="!value.comment" @click="update(null)">
          <v-list-item-title>Sperrung löschen</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-else class="text-center">
      {{ value.comment || "–" }}
    </div>
  </td>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: ["day", "time", "value", "wishId", "disabled"],
  name: "BlockItem",
  data() {
    return { items: ["Kinderbetreuung", "Andere Anstellung", "weitere"] };
  },

  computed: {},
  methods: {
    async update(newValue) {
      if (!newValue) {
        if (this.value.id > 0) {
          await this.apiDelete({
            resource: "teacher/wishslot",
            id: this.value.id,
          });
          this.$emit("update", newValue);
        }
        return;
      }
      await this.apiSave({
        resource: "teacher/wishslot",
        add: this.value.id === 0,
        data: {
          id: this.value.id,
          wish: this.wishId,
          time: this.time,
          day: this.day,
          comment: newValue,
          forced: true,
        },
      });
      this.$emit("update", newValue);
    },
  },
  created() {},
});
</script>
